export const DEFAULT_CONTEXT = {
  actions: {},
  states: {},
};
